module.exports = __webpack_public_path__ + "static/media/kosik.d238a1f4.jpg";